/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import checkType from"./checkType";import keysOf from"./keys";const clear=function(e){let r,t,c,f,o;if(checkType(e))return c=e,c.length=0,c;for(r=e,t=0,o=keysOf(r),f=o.length;t<f;t++)delete r[o[t]];return r};export default clear;